import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import {
  DeleteFilled,
  EditFilled,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';

import { Button, Input, Table, Tooltip } from 'antd';

import { printerCssHeader as columns } from '@/utils/tableHeader';
import '@/assets/style/modern-group-list.css';

// api
import { barcodeApiEndPoints } from '@/api/endpoints';
import { useFetch } from '@/hooks';

import { globalSearch } from '@/utils/search/Search';
import React from 'react';
import GlobalModal from '@/utils/modal/Modal';
import { handleDeleteApi } from '@/api/crud';
import { decryptData } from '@/components/reusable/crypto/Cipher';
import { useEffect } from 'react';
import { userData } from '@/common/custom-date-selector-list/helpers';

/**
 * roles list component
 * @returns
 */

const PrinterList = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [id, setId] = useState(null);
  const { data, isLoading, isSuccess, refresh } = useFetch(
    barcodeApiEndPoints.list,
  );

  const navigate = useNavigate();

  const handleOk = () => {
    setOpen(false);
    handleDeleteApi(id, barcodeApiEndPoints.delete, setLoading, refresh);
  };

  return (
    <>
      <div className="modern-group-page">
        <div className="modern-group-header-row">
          <div className="modern-group-header">
            <h1 className="modern-group-title">Printer Settings</h1>
            <p className="modern-group-subtitle">
              Manage and organize your printers
            </p>
          </div>
          <div className="modern-group-actions">
            <Input
              className="header-search"
              name="query"
              placeholder="Search printer..."
              value={searchQuery}
              prefix={<SearchOutlined />}
              onChange={(event) => setSearchQuery(event.target.value)}
              style={{ width: '300px' }}
            />
            <Link to="/printer/create/">
              <Button type="primary" className="centered">
                <PlusOutlined />
                Create
              </Button>
            </Link>
          </div>
        </div>

        <div className="table-responsive modern-table-wrapper">
          <Table
            size="large"
            bordered
            loading={isLoading}
            columns={columns?.map((col) => ({
              ...col,
              onCell: () => ({
                style: {
                  padding: '6px 12px',
                },
              }),
            }))}
            scroll={{ x: true, y: 'calc(100vh - 220px)' }}
            className="ant-border-space"
            style={{ textAlign: 'center' }}
            pagination={{
              hideOnSinglePage: true,
            }}
            dataSource={
              isSuccess
                ? globalSearch(data, searchQuery)?.map((barcode, index) => {
                    return {
                      key: barcode.referenceId,
                      index: index + 1,

                      branch: (
                        <span className="font-bold cursor-pointer">
                          {barcode.branchName}
                        </span>
                      ),

                      action: (
                        <div className="ant-action tw-flex tw-gap-4 tw-justify-center tw-align-center">
                          <Tooltip title="Edit">
                            <span
                              className="edit tw-inline-flex tw-cursor-pointer hover:tw-bg-blue-200 tw-rounded-full tw-p-1"
                              onClick={() => {
                                navigate('/printer/barcode', {
                                  state: {
                                    branchId: barcode.branchId,
                                    referenceId: barcode.referenceId,
                                  },
                                });
                              }}
                            >
                              <EditFilled className="tw-text-blue-600" />
                            </span>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <span
                              className="text-danger tw-inline-flex tw-cursor-pointer hover:tw-bg-red-200 tw-rounded-full tw-p-1"
                              onClick={() => {
                                setOpen(true);
                                setId(barcode?.referenceId);
                              }}
                            >
                              <DeleteFilled />
                            </span>
                          </Tooltip>
                        </div>
                      ),
                    };
                  })
                : []
            }
          />
        </div>
        <GlobalModal
          isVisible={open}
          onConfirm={handleOk}
          onClose={() => setOpen(false)}
          type="delete"
        />
      </div>
    </>
  );
};

export default PrinterList;
